// fe/src/utils/utm.js
/**
 * UTM first-touch attribution.
 * Captures utm_* params from the URL on first visit and persists them
 * to localStorage. Never overwritten once set (first-touch model).
 */
export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
export const UTM_STORAGE_KEY = 'utm_attribution';

export const captureUtmParams = () => {
  try {
    if (localStorage.getItem(UTM_STORAGE_KEY)) return; // first-touch already stored
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    UTM_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) utm[key] = value;
    });
    if (Object.keys(utm).length === 0) return; // no utm params present
    utm.landing_page = window.location.pathname;
    utm.captured_at = new Date().toISOString();
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utm));
  } catch {
    // localStorage unavailable — attribution is best-effort
  }
};

export const getUtmParams = () => {
  try {
    const raw = localStorage.getItem(UTM_STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};
